// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Close = function Close(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.353 5.06a.996.996 0 0 0-1.407-1.407l-4.941 4.94L5.06 3.648a.996.996 0 0 0-1.407 1.407l4.94 4.94-4.945 4.946a.996.996 0 0 0 1.407 1.407l4.941-4.94 4.945 4.944a.996.996 0 0 0 1.408-1.407l-4.941-4.94z"
  }));
};
